import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_DOCUMENTS, 
  CREATE_DOCUMENT, 
  GET_DOCUMENT, 
  UPDATE_DOCUMENT, 
  DELETE_DOCUMENT,
  GET_COMPANY_DOCUMENTS, 
  GET_MY_DOCUMENTS, 
  ASSIGN_DOCUMENT_COMPANIES,
  GET_DOCUMENTS_ALL
} from "./actionTypes"

import {
  getDocumentsSuccess, 
  getDocumentsFail,
  createDocumentSuccess, 
  createDocumentFail,
  getDocumentSuccess, 
  getDocumentFail,
  updateDocumentSuccess, 
  updateDocumentFail,
  deleteDocumentSuccess, 
  deleteDocumentFail,
  assignDocumentCompaniesSuccess, 
  assignDocumentCompaniesFail,
  getDocumentsAllSuccess,
  getDocumentsAllFail,
} from "./actions"

import {
  documents, 
  createDocumentData, 
  getDocumentData, 
  updateDocumentData, 
  deleteDocumentData,
  companyDocuments, 
  myDocuments, 
  assignCompaniesToDocument
} from "helpers/backend-helper"

function* getDocuments({ payload }) {
  try {
    const res = yield call(documents, payload);
    yield put(getDocumentsSuccess(res?.data));
  } catch (error) {
    yield put(getDocumentsFail(error?.response?.data?.message || "Something went wrong"));
  }
}

function* getDocumentsAll({ payload }) {
  try {
    const res = yield call(documents, payload);
    yield put(getDocumentsAllSuccess(res?.data));
  } catch (error) {
    yield put(getDocumentsAllFail(error?.response?.data?.message || "Something went wrong"));
  }
}

function* createDocument({ payload: { data, history, getDocuments } }) {
  try {
    const res = yield call(createDocumentData, data);
    yield put(createDocumentSuccess(res));
    if (getDocuments) yield put(getDocuments());
    if (history) history("/resources"); 
  } catch (error) {
    yield put(createDocumentFail(error?.response?.data?.message || "Something went wrong"));
  }
}

function* getDocument({ payload: { id } }) {
  try {
    const res = yield call(getDocumentData, id);
    yield put(getDocumentSuccess(res?.data));
  } catch (error) {
    yield put(getDocumentFail(error?.response?.data?.message || "Something went wrong"));
  }
}

function* updateDocument({ payload: { id, data, history, getDocuments } }) {
  try {
    const res = yield call(updateDocumentData, { id, data });
    yield put(updateDocumentSuccess(res));
    if (getDocuments) yield put(getDocuments());
    if (history) history("/resources");
  } catch (error) {
    yield put(updateDocumentFail(error?.response?.data?.message || "Something went wrong"));
  }
}

function* deleteDocument({ payload: { history, getDocuments, docId } }) {
  try {
    const res = yield call(deleteDocumentData, docId);
    yield put(deleteDocumentSuccess(res));
    if (getDocuments) yield put(getDocuments());
    if (history) history("/resources");
  } catch (error) {
    yield put(deleteDocumentFail(error?.response?.data?.message || "Something went wrong"));
  }
}

function* getCompanyDocs({ payload: { companyId, params } }) {
  try {
    const res = yield call(companyDocuments, companyId, params);
    yield put(getDocumentsSuccess(res?.data)); 
  } catch (error) {
    yield put(getDocumentsFail(error?.response?.data?.message || "Something went wrong"));
  }
}

function* getMine({ payload }) {
  try {
    const res = yield call(myDocuments, payload);
    yield put(getDocumentsSuccess(res?.data));
  } catch (error) {
    yield put(getDocumentsFail(error?.response?.data?.message || "Something went wrong"));
  }
}

function* assignCompanies({ payload: { id, companyIds, getDocuments } }) {
  try {
    const res = yield call(assignCompaniesToDocument, id, companyIds);
    yield put(assignDocumentCompaniesSuccess(res));
    yield put(getDocuments());
  } catch (error) {
    yield put(assignDocumentCompaniesFail(error?.response?.data?.message || "Something went wrong"));
  }
}

export default function* documentsSaga() {
  yield takeEvery(GET_DOCUMENTS, getDocuments)
  yield takeEvery(GET_DOCUMENTS_ALL, getDocumentsAll)
  yield takeEvery(CREATE_DOCUMENT, createDocument)
  yield takeEvery(GET_DOCUMENT, getDocument)
  yield takeEvery(UPDATE_DOCUMENT, updateDocument)
  yield takeEvery(DELETE_DOCUMENT, deleteDocument)
  yield takeEvery(GET_COMPANY_DOCUMENTS, getCompanyDocs)
  yield takeEvery(GET_MY_DOCUMENTS, getMine)
  yield takeEvery(ASSIGN_DOCUMENT_COMPANIES, assignCompanies)
}
